import { __awaiter, __decorate, __generator, __metadata, __param } from "tslib";
import { NOT_LOGIN_TINYID, } from '../model/value-object/user-info/user-info.interface';
import { INetworkRequestService } from '../../base/request/network-request.interface';
import { lockOnce } from '@tencent/ark-utils/lib/decorator/lock';
import AccountAggregate from '../model/aggregate/account-aggregate';
import UserInfoRepository from '../repository/user-info';
import VipInfoRepository from '../repository/vip';
var AccountDomainService = /** @class */ (function () {
    function AccountDomainService(networkRequestService) {
        this.networkRequestService = networkRequestService;
        this.userInfoRepository = new UserInfoRepository(this.networkRequestService);
        this.vipInfoRepository = new VipInfoRepository(this.networkRequestService);
    }
    /**
     * 初始化账号领域
     * 无需统一初始化，提供空实现
     * 如若想初始化账号相关的数据，请查看接入文档：https://iwiki.woa.com/pages/viewpage.action?pageId=1902350186
     */
    AccountDomainService.prototype.init = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/];
            });
        });
    };
    // 直出 user_info 数据初始化领域服务
    AccountDomainService.prototype.createPersonalEnvAccountAggregateByUserInfoCgi = function (userInfo, userIndex) {
        var baseDate = this.changeFetchDataToBaseDate(userInfo, userIndex);
        this.accountAggregate = new AccountAggregate(this.networkRequestService, baseDate.tinyId, baseDate);
        this.accountAggregate.completionUserInfo(userInfo);
        return true;
    };
    AccountDomainService.prototype.createPersonalEnvAccountAggregateByBasicClientVars = function (userInfo) {
        if (userInfo) {
            this.accountAggregate = new AccountAggregate(this.networkRequestService, userInfo.tinyId || NOT_LOGIN_TINYID, userInfo);
            return true;
        }
        this.accountAggregate = new AccountAggregate(this.networkRequestService, NOT_LOGIN_TINYID);
        return false;
    };
    // 通过 user_info 接口更新聚合根
    AccountDomainService.prototype.updatePersonalEnvAccountAggregate = function (userIndex) {
        return __awaiter(this, void 0, void 0, function () {
            var language;
            var _a, _b, _c;
            return __generator(this, function (_d) {
                this.updateUserIndex(userIndex);
                language = (_c = (_b = (_a = this.accountAggregate) === null || _a === void 0 ? void 0 : _a.userInfo) === null || _b === void 0 ? void 0 : _b.settings) === null || _c === void 0 ? void 0 : _c.language;
                return [2 /*return*/, this.createPersonalEnvAccountAggregateForFetch(userIndex, language)];
            });
        });
    };
    // 通过 user_info 更新补充数据
    AccountDomainService.prototype.completionUserInfo = function () {
        return __awaiter(this, void 0, void 0, function () {
            var resData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.userInfoRepository.getPersonalUserInfo()];
                    case 1:
                        resData = (_a.sent()).resData;
                        if ((resData === null || resData === void 0 ? void 0 : resData.retcode) === 0 /* RETCODE.SUCCESS */) {
                            this.accountAggregate.completionUserInfo(resData.data);
                            return [2 /*return*/, true];
                        }
                        return [2 /*return*/, false];
                }
            });
        });
    };
    // 更新用户头像和昵称
    AccountDomainService.prototype.updatePersonalNicknameAndAvatar = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var resData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.userInfoRepository.updatePersonalNicknameAndAvatar(params)];
                    case 1:
                        resData = (_a.sent()).resData;
                        if ((resData === null || resData === void 0 ? void 0 : resData.retcode) === 0 /* RETCODE.SUCCESS */) {
                            return [2 /*return*/, true];
                        }
                        return [2 /*return*/, false];
                }
            });
        });
    };
    AccountDomainService.prototype.getUserVipInfo = function () {
        return __awaiter(this, void 0, void 0, function () {
            var resData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.vipInfoRepository.getPersonalVipInfo()];
                    case 1:
                        resData = (_a.sent()).resData;
                        if ((resData === null || resData === void 0 ? void 0 : resData.retcode) === 0 /* RETCODE.SUCCESS */) {
                            this.accountAggregate.completionVipInfo(resData.data);
                            return [2 /*return*/, true];
                        }
                        return [2 /*return*/, false];
                }
            });
        });
    };
    AccountDomainService.prototype.getTipsStatus = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var resData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.vipInfoRepository.getPersonalTipsShow(params)];
                    case 1:
                        resData = (_a.sent()).resData;
                        if ((resData === null || resData === void 0 ? void 0 : resData.retcode) === 0 /* RETCODE.SUCCESS */) {
                            return [2 /*return*/, resData.data.result.isShow];
                        }
                        return [2 /*return*/, false];
                }
            });
        });
    };
    AccountDomainService.prototype.createPersonalEnvAccountAggregateForFetch = function (userIndex, language) {
        return __awaiter(this, void 0, void 0, function () {
            var resData, baseDate;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.userInfoRepository.getPersonalUserInfo()];
                    case 1:
                        resData = (_a.sent()).resData;
                        if (!((resData === null || resData === void 0 ? void 0 : resData.retcode) === 0 /* RETCODE.SUCCESS */)) return [3 /*break*/, 3];
                        baseDate = this.changeFetchDataToBaseDate(resData.data, userIndex, language);
                        this.accountAggregate = new AccountAggregate(this.networkRequestService, resData.data.tinyid, baseDate);
                        this.accountAggregate.completionUserInfo(resData.data);
                        // 由于这里会初始化AccountAggregate，这里补拉一下 vipInfo
                        return [4 /*yield*/, this.getUserVipInfo()];
                    case 2:
                        // 由于这里会初始化AccountAggregate，这里补拉一下 vipInfo
                        _a.sent();
                        return [2 /*return*/, true];
                    case 3: return [2 /*return*/, false];
                }
            });
        });
    };
    AccountDomainService.prototype.changeFetchDataToBaseDate = function (userInfo, nowUserIndex, language) {
        var corpId = userInfo.corpId, tinyid = userInfo.tinyid, corpName = userInfo.corpName, englishName = userInfo.englishName, loginType = userInfo.loginType, wxOpenid = userInfo.wxOpenid, uin = userInfo.uin, uidSource = userInfo.uidSource, userId = userInfo.userId, avatar = userInfo.avatar, nick = userInfo.nick;
        return {
            corpId: corpId,
            corpName: corpName,
            englishName: englishName,
            loginType: loginType,
            uin: uin,
            uidSource: uidSource,
            // TODO：背景是 user_info 接口不会返回没有 userId，userId 的有登录态的逻辑是 p. + tinyId，网关是自己处理的，这里前端也补充逻辑
            userId: userId !== null && userId !== void 0 ? userId : "p.".concat(tinyid),
            nowUserIndex: nowUserIndex !== null && nowUserIndex !== void 0 ? nowUserIndex : '',
            tinyId: tinyid,
            openId: wxOpenid,
            userName: nick,
            userPic: avatar,
            settings: {
                language: language !== null && language !== void 0 ? language : '',
                toolbarMode: '',
                vipTheme: '',
                openWithDesktop: '',
            },
        };
    };
    AccountDomainService.prototype.updateUserIndex = function (userIndex) {
        // TODO: 因为目前多登录的所有接口依赖window.nowUserIndex, 所以这里暂时这样处理
        this.accountAggregate.updateNowUserIndex(userIndex);
    };
    __decorate([
        lockOnce(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", Promise)
    ], AccountDomainService.prototype, "init", null);
    AccountDomainService = __decorate([
        __param(0, INetworkRequestService),
        __metadata("design:paramtypes", [Object])
    ], AccountDomainService);
    return AccountDomainService;
}());
export { AccountDomainService };
